import React from 'react'

const BidraSammen = () => {
  return (
    <section className="project">
      <p>This is Bidra Sammen Graduation Project</p>
      <video width="320" height="240" controls>
        <source src="https://res.cloudinary.com/diggrhtle/video/upload/v1604416370/persona%20page/Cloud0x9_Product_Demo_rjclga.mp4" type="video/mp4" />
            Your browser does not support the video tag.
      </video>
    </section>
  )
}

export default BidraSammen;